const Address = () =>  {

	var formId = ".address-form-wrapper";
	$(formId + " .search-box__submit").on("click", function (e) {
		
		var wrapper = $(this).parents().eq(2);
		var input = wrapper.find(".search-box__input");
		var postcode = input.val();
		
		if (postcode !== '') {

            $.get(apilocation + "postcodeapi/PostcodeLookup?postcode=" + postcode, function (response) {

				if (response.length > 0) {
					wrapper.find(".address-not-found").hide();
					wrapper.find(".address-section").show();
					wrapper.find(".address-dropdown").show();
					wrapper.find(".dropdown__select").empty();


					wrapper.find(".dropdown__select").append($('<option>').val('').text('Please Select'));

					for (var i = 0; i < response.length; i++) {
						wrapper.find(".dropdown__select").append($('<option>').val(response[i].Id).text(response[i].Text));
					}

					wrapper.find(".dropdown__select").on("change", function () {

						var lookupId = this.value;

                        $.get(apilocation + "postcodeapi/GetAddressFromPostcodeLookup?lookupId=" + lookupId, function (response) {

							wrapper.find(".address1").val(response.Address1).blur();
							wrapper.find(".buildingNumber").val(response.BuildingNumber).blur(); // Addition for finance eligibility
							wrapper.find(".address2").val(response.Address2).trigger('keyup');
							wrapper.find(".street").val(response.Street).trigger('keyup'); // Addition for finance eligibility

							wrapper.find(".city").val(response.City).blur();
							wrapper.find(".postcode").val(response.Postcode).blur();

							wrapper.find("input").removeClass("error");
							wrapper.find("input").removeClass("input-validation-error");
							 
							wrapper.find(".field-validation-error").hide();
						});
					});

				} else {
					wrapper.find(".address-not-found").show();
					wrapper.find(".address-section").show();
					wrapper.find(".address-dropdown").hide();
				}


			});
		}

		return false;

	});
}

export default Address;